import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { QuestionReport } from './question-report';
import { MatchingSubQuestionReport } from '../sub-question-report';
export var MatchingQuestionReport = /*#__PURE__*/function (_QuestionReport) {
  _inherits(MatchingQuestionReport, _QuestionReport);

  var _super = _createSuper(MatchingQuestionReport);

  function MatchingQuestionReport() {
    _classCallCheck(this, MatchingQuestionReport);

    return _super.apply(this, arguments);
  }

  _createClass(MatchingQuestionReport, [{
    key: "subQuestionReports",
    get: function get() {
      return this.props.subQuestionReports;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.subQuestionReports,
        argumentName: 'Sub Question Reports'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new MatchingQuestionReport(props, new UniqueEntityID(props.id.toString())));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var subQuestionReports = data.subQuestionReports;

        var basePropsOrError = _get(_getPrototypeOf(MatchingQuestionReport), "createBaseProps", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var baseProps = basePropsOrError.getValue();
        var subQuestionReportsOrError = subQuestionReports === null || subQuestionReports === void 0 ? void 0 : subQuestionReports.map(function (answerReport) {
          return MatchingSubQuestionReport.fromJson(answerReport);
        });
        var matchingMatchingSubQuestionReportResultOrErrorCombined = Result.combineArray(subQuestionReportsOrError);
        if (matchingMatchingSubQuestionReportResultOrErrorCombined.isFailure) return Result.fail(matchingMatchingSubQuestionReportResultOrErrorCombined.error);
        var matchingQuestionReportOrError = this.create(_objectSpread(_objectSpread({}, baseProps), {}, {
          subQuestionReports: matchingMatchingSubQuestionReportResultOrErrorCombined.getValue()
        }));

        if (matchingQuestionReportOrError.isFailure) {
          return Result.fail(matchingQuestionReportOrError.error);
        }

        var matchingQuestionReport = matchingQuestionReportOrError.getValue();
        return Result.ok(matchingQuestionReport);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return MatchingQuestionReport;
}(QuestionReport);